import React, { useContext } from "react";
import { Flex, Text, Box, TransparentButton, Divider } from "flicket-ui";
import { useRouter } from "next/router";
import useSWR from "swr";

import {
  Layout,
  Footer,
  BottomBar,
  Menu,
  Seo,
  Icon,
  PageContainer,
  SlateRenderer,
  Status,
} from "~components";
import { EventTitle } from "~components/events/events.Title";
import { BaseContext } from "~context";
import { sdk } from "~lib";

const getEvent = async (_: string, orgId: string, eventId) =>
  sdk({ orgId })
    .event({ id: eventId })
    .then((res) => res.event);

const swrConfig = {
  shouldRetryOnError: false,
};

const TermsAndConditions = () => {
  const router = useRouter();
  const { organization } = useContext(BaseContext);

  const { data: event, error } = useSWR(
    ["event", organization.id, router.query.eventId],
    getEvent,
    swrConfig
  );

  const pageTitle = (() => {
    let pre = "";

    if (event?.title) {
      pre = event.title + ": ";
    }
    return pre + "Terms and Conditions";
  })();

  const termsAndConditions =
    event?.termsAndConditions ?? organization.termsAndConditions;

  return (
    <>
      <Seo title={pageTitle} description={pageTitle} />
      <Menu />
      <Status loading={!event && !error} error={error}>
        <Flex flexDirection="column" flex={1}>
          <Box d={{ _: "block", md: "none" }}>
            <Flex px={2} py={3}>
              <TransparentButton mr={2} to={`/events/${event?.id}`}>
                <Icon icon="chevron-left" fontSize={6} color="N800" />
              </TransparentButton>
              <Text
                lineHeight="normal"
                fontSize={6}
                fontWeight="extraBold"
                color="N800"
              >
                {pageTitle}
              </Text>
            </Flex>
            <Divider />
          </Box>
          <Flex
            flexDirection="column"
            flex={1}
            maxH={{ _: "calc(100vh - 73px)", md: "unset" }}
            overflowY={{ _: "auto", md: "visible" }}
          >
            <Layout layoutType="overlay">
              <PageContainer
                backgroundImage={event?.backgroundImage}
                backgroundImageFullPage={event?.backgroundImageFullPage}
                bannerImage={null}
                footer={<Footer />}
                title={
                  <EventTitle
                    backToLinkText="Back to Event"
                    backToLink={`/events/${event?.id}`}
                    isSinglePage={false}
                    title={pageTitle}
                    startDate={event?.startDate}
                    endDate={event?.endDate}
                    city={event?.venue?.address?.city}
                    venueName={event?.venue?.name}
                  />
                }
              >
                {termsAndConditions ? (
                  <SlateRenderer value={termsAndConditions} />
                ) : (
                  <Text mb={{ _: 1, md: 2 }}>
                    Terms and Conditions coming soon!
                  </Text>
                )}
              </PageContainer>
            </Layout>
          </Flex>
        </Flex>
        <BottomBar />
      </Status>
    </>
  );
};

export default TermsAndConditions;
